export default __webpack_public_path__ + "static/media/Icon1.69f888b1.png";